import { render, staticRenderFns } from "./Shortcuts.vue?vue&type=template&id=4115b0e7"
import script from "./Shortcuts.vue?vue&type=script&lang=js"
export * from "./Shortcuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports